import { useInfiniteQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { getCryptoTransactions } from '../cryptoWalletEndpoints'
import { cryptoWalletKeys } from '../cryptoWalletQueryKeys'
import type { ParsedCryptoTransactionsPage } from '../cryptoWalletParser'
import type { CryptoTransactionFilters } from '../../types/cryptoWalletTypes'

const PAGE_LIMIT = 20

export function useCryptoTransactionsQuery(
  filters: MaybeRefOrGetter<CryptoTransactionFilters>,
  /** Skip the request entirely — used when a screen has two possible sources. */
  enabled: MaybeRefOrGetter<boolean> = true,
) {
  return useInfiniteQuery<ParsedCryptoTransactionsPage>({
    enabled: () => toValue(enabled),
    queryKey: () => cryptoWalletKeys.transactionList(toValue(filters)),
    queryFn: ({ pageParam }) =>
      getCryptoTransactions({
        page: pageParam as number,
        limit: PAGE_LIMIT,
        filters: toValue(filters),
      }),
    initialPageParam: 1,
    // The endpoint returns a bare array, so a short page is the end signal —
    // see parseCryptoTransactions.
    getNextPageParam: (lastPage, allPages) =>
      lastPage.isLastPage ? undefined : allPages.length + 1,
  })
}
